import React from "react";
import { ParagraphText } from "../../../styles/SharedStyles";
import UtilsUnit from "../../../utils/UtilsUnit";
import ConstantsTexts from "../../../constants/ConstantsTexts";
import "./WidgetGaugeUI.css";

const WidgetGaugeUI = ({
  numberText,
  sizeProp = "4.4rem",
  textSizeProp = "1.6rem",
  backgroundColor = UtilsUnit.getGaugeNumberBackgroundColor(numberText),
  textColor = UtilsUnit.getGaugeNumberTextColor(numberText),
  textWeight = "500",
  boxShadow = "0rem 0rem 1.6rem 0rem rgba(0, 0, 0, 0.15)",
  isEmptyData = false,
  previousValue = null,
  showPreviousWhenSet = false,
}) => {
  // Override background color if isEmptyData is true
  const finalBackgroundColor = isEmptyData ? "#DFDFDF" : backgroundColor;
  const showPreviousBadge =
    !isEmptyData &&
    previousValue != null &&
    previousValue !== "" &&
    (showPreviousWhenSet || Number(previousValue) !== Number(numberText));

  return (
    <div className={`gauge-ui-wrap${showPreviousBadge ? " gauge-ui-wrap--has-previous" : ""}`}>
      {showPreviousBadge && (
        <div className="gauge-ui-was-badge">
          <ParagraphText className="gauge-ui-was-badge-text">
            {ConstantsTexts.CODE_272}
            {UtilsUnit.getGaugeNumberText(previousValue)}
          </ParagraphText>
        </div>
      )}
      <div
        className="gauge-ui-frame"
        style={{
          width: sizeProp,
          height: sizeProp,
          backgroundColor: finalBackgroundColor,
          boxShadow: boxShadow,
        }}
      >
        <ParagraphText
          className="gauge-ui-text"
          style={{
            fontSize: textSizeProp,
            color: textColor,
            fontWeight: textWeight,
          }}
        >
          {isEmptyData ? "- -" : UtilsUnit.getGaugeNumberText(numberText)}
        </ParagraphText>
      </div>
    </div>
  );
};

export default WidgetGaugeUI;
